<template>
    <v-app>
        <v-system-bar color="primary" app>
            <v-spacer></v-spacer>
        </v-system-bar>
        <v-navigation-drawer app>
            <div class="wrap-logo"></div>
        </v-navigation-drawer>

        <v-main>
            <v-container fluid>
                <router-view />
                <loader />
            </v-container>
        </v-main>
        <v-footer app="app" color="primary">
            <v-flex class="text-center">© 2021. All rights reserved.</v-flex>
        </v-footer>
    </v-app>
</template>

<script>
    import Loader from "@/components/Loader";
    export default {
        name: "App",

        components: {
            Loader
        },

        data: () => ({
        }),
    };
</script>

<style>
    .wrap-logo {
        background: url(assets/bg-left.jpg);
        background-repeat: no-repeat;
        background-size: 588px 503px;
        height: 100%;
        width: 100%;
    }
</style>
